function generateCascadeInitialSelections(
  data,
  selections,
  SubStepTitle,
  CascadeName,
  Cascades,
) {
  if (Cascades !== "-") {
    Cascades.split("|").forEach((oneCascade) => {
      let firstOption = data.filter((d) => d.Context === oneCascade)[0];

      selections[SubStepTitle][CascadeName][oneCascade] = firstOption.VariantID;
      if (firstOption.Cascades !== "-")
        generateCascadeInitialSelections(
          data,
          selections,
          SubStepTitle,
          CascadeName,
          firstOption.Cascades,
        );
    });
    // selections[SubStepTitle][CascadeName][Context] = ''
  }

  return selections;
}

export function generateInitialSelections(data) {
  const selections = {};

  data.forEach((item) => {
    const {
      SubStepTitle,
      CascadeName,
      Context,
      VariantID,
      Cascaded,
      Cascades,
    } = item;

    if (!selections[SubStepTitle]) {
      selections[SubStepTitle] = {};
    }

    if (!selections[SubStepTitle][CascadeName]) {
      selections[SubStepTitle][CascadeName] = {};
    }

    // Only set if Context does not exist yet
    if (!selections[SubStepTitle][CascadeName].hasOwnProperty(Context)) {
      if (Cascaded === "FALSE") {
        selections[SubStepTitle][CascadeName][Context] = VariantID;
        generateCascadeInitialSelections(
          data,
          selections,
          SubStepTitle,
          CascadeName,
          Cascades,
        );
        // if (Cascades !== "-") {
        //   Cascades.split("|").forEach((oneCascade) => {
        //     let firstOption = data.filter((d) => d.Context === oneCascade)[0];
        //     selections[SubStepTitle][CascadeName][oneCascade] =
        //       firstOption.VariantID;
        //   });
        // }
      } else {
        selections[SubStepTitle][CascadeName][Context] = "-";
      }
      // else {
      //   let firstOptionOfCascade = data.filter((d) => {
      //     return (
      //       d.VariantID === VariantID &&
      //       d.CascadeName === CascadeName &&
      //       d.Cascades === "-"
      //     );
      //   })[0];

      //   if (firstOptionOfCascade)
      //     selections[SubStepTitle][CascadeName][Context] =
      //       firstOptionOfCascade?.VariantID;
      //   else selections[SubStepTitle][CascadeName][Context] = "-";
      // }
    }
  });

  return selections;
}
